import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './LegalPage.css';

const LegalNav = () => {
  const { pathname } = useLocation();
  return (
    <nav className="legal-nav">
      <Link to="/legal/aviso-legal" className={pathname === '/legal/aviso-legal' ? 'active' : ''}>Aviso legal</Link>
      <Link to="/legal/privacidad" className={pathname === '/legal/privacidad' ? 'active' : ''}>Política de privacidad</Link>
      <Link to="/legal/terminos" className={pathname === '/legal/terminos' ? 'active' : ''}>Términos y condiciones</Link>
      <Link to="/legal/cookies" className={pathname === '/legal/cookies' ? 'active' : ''}>Política de cookies</Link>
    </nav>
  );
};

const PrivacyPolicy = () => (
  <div className="legal-page">
    <h1>Política de privacidad</h1>
    <p className="legal-updated">Última actualización: octubre de 2026</p>
    <LegalNav />

    <h2>1. Responsable del tratamiento</h2>
    <p>
      El responsable del tratamiento de los datos personales recogidos a través de <strong>almaley.com</strong> y <strong>app.almaley.com</strong> es:
    </p>
    <ul>
      <li><strong>Titular:</strong> Eva Bravo Ruiz (en adelante, «Almaley»).</li>
      <li><strong>NIF:</strong> 03874215A</li>
      <li><strong>Domicilio:</strong> Calle Maravillas, 24, Cabañas de la Sagra (Toledo).</li>
      <li><strong>Correo electrónico:</strong> <a href="mailto:legal@almaley.com">legal@almaley.com</a></li>
    </ul>

    <h2>2. Datos que recogemos</h2>
    <ul>
      <li><strong>Datos de cuenta:</strong> correo electrónico y, si te registras con correo y contraseña, una contraseña que guardamos cifrada (nunca en texto legible). Si entras con Google, recibimos tu nombre y tu correo. También registramos la fecha de alta, la de tu último acceso y si has verificado tu correo.</li>
      <li><strong>Datos de perfil (opcionales):</strong> nombre, ciudad, oposiciones que te interesan y si quieres recibir notificaciones.</li>
      <li><strong>Datos de uso:</strong> respuestas a exámenes y preguntas de práctica, progreso en los temarios y artículos que has leído.</li>
      <li><strong>Asistente de chat y preguntas abiertas:</strong> las preguntas que escribes al asistente, sus respuestas y las respuestas que das a las preguntas abiertas para que la IA las corrija. Guardamos la conversación para que el asistente mantenga el contexto.</li>
      <li><strong>Formulario de contacto:</strong> nombre, correo electrónico y mensaje.</li>
      <li><strong>Datos técnicos:</strong> dirección IP, tipo de navegador y páginas visitadas, que se tratan de forma automática para el funcionamiento y la seguridad del servicio, incluida la limitación de intentos para evitar abusos.</li>
    </ul>
    <p>
      Te pedimos que no incluyas datos personales sensibles (salud, ideología, etc.) ni datos de terceros en tus preguntas al asistente, ya que se envían a un proveedor de IA para generar la respuesta.
    </p>

    <h2>3. Finalidad y base jurídica</h2>
    <ul>
      <li><strong>Prestación del servicio:</strong> gestionar tu cuenta, mostrar tu progreso, responder a tus preguntas con el asistente y corregir tus respuestas abiertas (base: ejecución de contrato).</li>
      <li><strong>Atender tus consultas:</strong> responder a los mensajes que envías por el formulario de contacto (base: tu consentimiento al marcar la casilla del formulario).</li>
      <li><strong>Seguridad y prevención de abuso:</strong> proteger los formularios de registro y contacto frente a bots y accesos no autorizados (base: interés legítimo).</li>
      <li><strong>Mejora del servicio:</strong> analizar el uso agregado de la plataforma para mejorar sus funcionalidades (base: interés legítimo).</li>
      <li><strong>Comunicaciones:</strong> enviarte notificaciones relacionadas con tu cuenta, siempre que lo hayas aceptado (base: consentimiento).</li>
    </ul>
    <p>No tomamos decisiones automatizadas que produzcan efectos jurídicos sobre ti.</p>

    <h2>4. Conservación de los datos</h2>
    <p>
      Conservamos los datos de tu cuenta mientras la mantengas activa. Si solicitas la eliminación de tu cuenta, borraremos tus datos personales en un plazo máximo de 30 días, salvo obligación legal de conservación. Los mensajes del formulario de contacto se conservan el tiempo necesario para atender tu consulta.
    </p>

    <h2>5. Destinatarios y proveedores</h2>
    <p>No vendemos tus datos ni los cedemos a terceros con fines propios. Para prestar el servicio utilizamos proveedores que tratan datos en nuestro nombre:</p>
    <ul>
      <li><strong>OpenAI</strong>: procesa las preguntas que haces al asistente y las respuestas que das a las preguntas abiertas para generar respuestas y correcciones.</li>
      <li><strong>Google</strong>: inicio de sesión con Google (solo si lo eliges), servicio reCAPTCHA en el registro y en el formulario de contacto (Google recibe datos como tu IP y información de tu navegador para distinguir personas de bots) y correo corporativo en el que recibimos tus mensajes.</li>
      <li><strong>Resend</strong>: envío de correos electrónicos (verificación de cuenta y entrega de los mensajes del formulario de contacto).</li>
      <li><strong>Render</strong>: alojamiento de la aplicación y de la web.</li>
      <li><strong>Neo4j (Aura)</strong>: base de datos donde se almacenan el temario, tu cuenta y tu progreso.</li>
    </ul>
    <p>
      Algunos de estos proveedores tratan datos fuera del Espacio Económico Europeo (principalmente en Estados Unidos). En esos casos la transferencia se ampara en las garantías que prevé el RGPD, como la decisión de adecuación del Marco de Privacidad de Datos UE-EE. UU. o las cláusulas contractuales tipo.
    </p>

    <h2>6. Tus derechos</h2>
    <p>Puedes ejercer en cualquier momento los derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad, así como retirar tu consentimiento cuando sea la base del tratamiento, escribiendo a <a href="mailto:legal@almaley.com">legal@almaley.com</a>. También tienes derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).</p>

    <h2>7. Seguridad</h2>
    <p>
      Aplicamos medidas técnicas y organizativas adecuadas para proteger tus datos frente a accesos no autorizados, pérdida o destrucción, incluyendo cifrado en tránsito (HTTPS), contraseñas almacenadas con hash y cookies de sesión con flag HttpOnly y Secure.
    </p>

    <h2>8. Edad mínima</h2>
    <p>
      Para registrarte debes tener al menos 16 años. Si detectamos una cuenta de una persona menor de esa edad, la eliminaremos.
    </p>

    <h2>9. Cambios en esta política</h2>
    <p>
      Podemos actualizar esta política ocasionalmente. Te notificaremos cualquier cambio relevante mediante un aviso en la plataforma o por correo electrónico.
    </p>
  </div>
);

export { LegalNav };
export default PrivacyPolicy;
